export const POPUP = Object.freeze({
  // dialog xac nhan reject account
  RESET_PASSWORD: 'ResetPassword',
  REGISTER_POPUP: 'Register',
  UPDATE_POPUP: 'Update',
  UPDATE_ACCOUNT: 'UpdateAccount',
  UPDATE_HISTORY_POPUP: 'HistoryPanel',
  UPDATE_PARTNER_POPUP: 'UpdatePartner',
  REQUEST_LICENSE_INFO: 'RequestLicenseInfo',
});